import { Link, NavLink } from "react-router-dom";
import { FiEye, FiTrash2 } from "react-icons/fi";
import Delete from "../Modals/delete";
import { useState } from "react";
import { connect } from "react-redux";
import moment from "moment";
import {
  deleteCampaign,
  runCampaign,
} from "../../stores/actions/campaign.actions.types";
import ConfirmationCampaign from "../Modals/campaign-confirmation";
import { VscDebugStart } from "react-icons/vsc";
import { BiEdit } from "react-icons/bi";
import { successMessage } from "../../utilities/notification";

const statusBadge = (status) => {
  const base = "px-2 py-1 rounded text-xs font-medium capitalize";

  switch (status) {
    case "sent":
      return `${base} bg-green-100 text-green-700`;
    case "pending":
      return `${base} bg-yellow-100 text-yellow-700`;
    case "failed":
      return `${base} bg-red-100 text-red-700`;
    case "partial":
      return `${base} bg-purple-200 text-purple-700`;
    default:
      return `${base} bg-gray-200 text-gray-700`;
  }
};

const CampaignTable = ({
  campaigns,
  runCampaign,
  deleteCampaign,
  setCampaigns,
  setReload,
  reload,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCampaignOpen, setIsModalCampaignOpen] = useState(false);
  const [campaignId, setCampaignId] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [campaignLoading, setCampaignLoading] = useState(false);

  const handleDelete = async () => {
    setDeleteLoading(true);
    const callback = (data) => {
      if (data.success) {
        setCampaigns((prev) => prev.filter((item) => item._id !== campaignId));
        setDeleteLoading(false);
        setIsModalOpen(false);
      } else {
        setDeleteLoading(false);
      }
    };

    deleteCampaign({ id: campaignId, callback });
  };

  const handleRunCampaign = async () => {
    setCampaignLoading(true);
    const callback = (data) => {
      if (data.success) {
        setIsModalCampaignOpen(false);
        successMessage("Campaing has been done");
        setReload(!reload);
        setCampaignLoading(false);
      } else {
        successMessage("Campaing has been failed");
        setCampaignLoading(false);
      }
    };
    runCampaign({ id: campaignId, callback });
  };

  const handleDeleteClick = (id) => {
    setCampaignId(id);
    setIsModalOpen(true);
  };
  const handleCampaignClick = (id) => {
    setCampaignId(id);
    setIsModalCampaignOpen(true);
  };

  return (
    <div className='rounded-[10px] bg-white drop-shadow-1 border-l border-slate-300 dark:border-slate-700 dark:bg-boxdark dark:drop-shadow-none border border-stroke bg-white p-4 shadow-1 dark:border-dark-3 dark:bg-gray-dark dark:shadow-card sm:p-2.5 transition-colors duration-300'>
      <div className='max-w-full overflow-x-auto overflow-y-hidden pb-6'>
        <table className='w-full table-auto'>
          <thead>
            <tr className='bg-[#F7F9FC] dark:bg-black text-left dark:bg-dark-2'>
              <th className='min-w-[220px] px-4 py-2 font-medium text-dark dark:text-white xl:pl-7.5'>
                Campaign Name
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Type
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Status
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Audience
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Sent Count
              </th>
              <th className='min-w-[150px] px-4 py-2 font-medium text-dark dark:text-white'>
                Failed Count
              </th>

              <th className='min-w-[200px] px-4 py-2 font-medium text-dark dark:text-white'>
                Updated Time
              </th>
              <th className='min-w-[120px] px-4 py-2 text-right font-medium text-dark dark:text-white xl:pr-7.5'>
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {campaigns.map((campaign, index) => (
              <tr key={campaign?._id} className='text-sm'>
                {/* Campaign Name */}
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pl-7.5 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {campaign?.name}
                  </span>
                </td>

                {/* Type */}
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='capitalize text-dark dark:text-white'>
                    {campaign?.type}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className={statusBadge(campaign.status)}>
                    {campaign.status}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark capitalize dark:text-white'>
                    {campaign?.targetedAudience || "All"}
                  </span>
                </td>

                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {campaign?.sentCount}
                  </span>
                </td>
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {campaign?.failedCount}
                  </span>
                </td>

                {/* Updated At */}
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <span className='text-dark dark:text-white'>
                    {moment(campaign?.updatedAt || campaign?.createdAt).format(
                      "D MMM YYYY, hh:mm A"
                    )}
                  </span>
                </td>

                {/* Actions */}
                <td
                  className={`border-[#eee] px-4 py-2 dark:border-dark-3 xl:pr-7.5 ${
                    index === campaigns.length - 1 ? "border-b-0" : "border-b"
                  }`}
                >
                  <div className='flex items-center justify-end space-x-3.5'>
                    <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleCampaignClick(campaign?._id)}
                      >
                        <VscDebugStart className='text-lg' />
                      </button>
                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Run Campaign
                      </span>
                    </div>
                    {/* View Details */}
                    <div className='group relative'>
                      <NavLink to={`/campaign/details/${campaign?._id}`}>
                        <button className='mt-[7px] hover:text-primary'>
                          <FiEye className='text-lg' />
                        </button>
                      </NavLink>
                      <span className='absolute left-1/2 top-full w-[60px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-black opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-gray-800 dark:text-white'>
                        Details
                      </span>
                    </div>

                    {/* Delete */}

                    <div className='group relative'>
                      <Link
                        to={`/campaign/${
                          [
                            "general-sms",
                            "pending-sms",
                            "cart-funnel-sms",
                          ].includes(campaign?.type)
                            ? "update-sms-campaign"
                            : "update-email-campaign"
                        }/${campaign?._id}?type=${campaign?.type}`}
                        className='mt-[7px] hover:text-primary'
                      >
                        <BiEdit className='text-lg' />
                      </Link>

                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Edit
                      </span>
                    </div>

                    <div className='group relative'>
                      <button
                        className='mt-[7px] hover:text-primary'
                        onClick={() => handleDeleteClick(campaign?._id)}
                      >
                        <FiTrash2 className='text-lg' />
                      </button>
                      <span className='absolute left-1/2 top-full w-[50px] -translate-x-1/2 transform rounded bg-gray-7 px-2 py-1 text-xs text-white opacity-0 transition-opacity duration-500 group-hover:opacity-100 dark:bg-white dark:text-gray-700'>
                        Delete
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Delete
        opened={isModalOpen}
        setOpend={setIsModalOpen}
        title='Delete Campaign'
        handleDelete={handleDelete}
        loading={deleteLoading}
      />
      <ConfirmationCampaign
        opened={isModalCampaignOpen}
        setOpend={setIsModalCampaignOpen}
        title='Run Campaign'
        handler={handleRunCampaign}
        loading={campaignLoading}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({ loading: state?.app?.visible });

export default connect(mapStateToProps, { deleteCampaign, runCampaign })(
  CampaignTable
);
